module.exports = __webpack_public_path__ + "static/img/viewAv4.df0c625a.png";